module.exports = __webpack_public_path__ + "img/logo_dark.1f82918b.svg";